<template>
  <div class="vx-col w-full lg:w-1/4 sm:w-1/2 mb-base">
    <vx-card class="text-center" style="height:180px;">
      <div v-if="spaceInfo" class="text-center">
        <div  class="vx-row justify-end">
          <div  style="width: 20%;">
            <div align="left">
              <vx-tooltip v-if="spaceInfo.alone" style="margin-left:-35px; padding:5px;" color="primary" text="개인 클래스" position="top">
                <!-- <vs-chip color="#d5d5d5">종강</vs-chip> -->
                <feather-icon icon="UserIcon"/>
              </vx-tooltip>
              <vx-tooltip v-if="spaceInfo.alone==false" style="margin-left:-35px; padding:3px;" color="warning" text="공유 클래스" position="top">
                <vs-chip v-if="!spaceInfo.service" color="#d5d5d5">종강</vs-chip>
                <vs-chip v-if="spaceInfo.service" color="success">개강</vs-chip>
                <feather-icon icon="UsersIcon"/>
              </vx-tooltip>
            </div>
          </div>
          <div class="vx-row justify-end" style="width: 80%;">
            <div v-if='spaceInfo.level == 5' class="flex items-center"  @click="workspacePopup =true">
              <vs-button class="flex items-center" style="margin:3px;" color="dark" type="flat" icon="icon-edit" icon-pack="feather" />
            </div>
            <div v-if='spaceInfo.level == 5' class="flex items-center" @click="workspaceDelete()">
              <vs-button class="flex items-center" style="margin:3px;" color="danger" type="flat" icon="icon-trash" icon-pack="feather" />
            </div>
            <!-- <div v-if='spaceInfo.level != 5' class="flex items-center" @click="userWorkspaceDelete()">
              <vs-button class="flex items-center" style="margin:3px;" color="danger" type="flat" icon="icon-user-x" icon-pack="feather" />
            </div> -->
          </div>
        </div>
        <vs-button class="w-full" color="primary" type="flat" style="font-size: 15px; width:15px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block;" @click="show()"><strong>{{title}}</strong></vs-button>
      </div>
      <!-- <div v-if="!spaceInfo" class="p-6 text-center">
        <div class="vx-row justify-center">
          <vs-button color="dark" type="border" icon-pack="feather" icon="icon-plus" size="small" @click="createSpace()" style="margin-top:20px; margin-right:10px;"/>
          <p class="text" style="margin-top:22px;" @click="createSpace()"> 클래스 만들기 </p>
        </div>
      </div> -->
      <div v-if="spaceInfo">
        <vs-divider style="margin-top:2px;"/>
        <div class="flex justify-center flex-wrap" style="margin-top:10px;">
          <p style="margin-right:5px;">프로젝트</p> &nbsp;
          <vs-button color="primary" style="margin-right:3px" type="border" icon-pack="feather" size="small" icon="icon-list" @click="viewProject()"></vs-button>
          <vs-button color="primary" style="margin-right:3px" type="border" icon-pack="feather" size="small" icon="icon-plus" @click="createProject()"/>
          <!-- <vs-button class="w-1/2 justify-center" color="primary" type="border" size="small"  @click="createProject()">생성</vs-button> -->
        </div>
      </div>
    </vx-card>
    <vs-popup ref="namePopup" classContent="popup-example" :active.sync="workspacePopup" @cancel="clearFields"  @close="clearFields">
      <h4 class="text-center">클래스 이름을 변경합니다.</h4> &nbsp;
      <div class="vs-con-input w-full">
        <vs-input icon-pack="feather" color="dark" icon="icon-edit-2" size="large" placeholder="클래스명을 입력하세요." v-model="title" class="is-label-placeholder w-full lg:w-full mb-4" />
        <br/>
        <vs-button class="w-full mb-2" @click="updateWorkspace()" color="primary" type="filled">완료</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  props: ['spaceInfo'],
  data() {
    return {
      title: 'AClass',
      workspacePopup:false
    }
  },
  created () {
    if (this.spaceInfo) {
      this.title = this.spaceInfo.title
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },
  methods: {
    createSpace() {
      this.$router.push('/pages/space/create')
    },
    clearFields() {
      this.$nextTick(() => {
      })
    },
    workspaceDelete(){
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `클래스삭제`,
        text: '정말 삭제하시겠습니까? 클래스정보와 클래스에 포함된 프로젝트가 모두 삭제됩니다.',
        accept: this.accept
      })
    },
    accept(){
      this.$store.dispatch('space/deleteWorkspace',  this.spaceInfo.id)
      .then(() => {
        this.workspacePopup = false
        this.$vs.notify({
          color: 'success',
          title: '완료',
          text: '클래스을 삭제하였습니다.'
        })
        this.$emit('delete', this.spaceInfo.id)
      }).catch(() => {
        this.workspacePopup = false
        this.$vs.notify({
          color: 'danger',
          title: '실패',
          text: '관리자에게 문의 부탁 드립니다.'
        })
      })
    },
    updateWorkspace(){
      this.$store.dispatch('space/updateWorkspaceTitle', {'id': this.spaceInfo.id, 'title': this.title})
      .then(() => {
        this.workspacePopup = false
        this.$vs.notify({
          color: 'success',
          title: '완료',
          text: '클래스명을 수정하였습니다.'
        })
      }).catch(() => {
        this.workspacePopup = false
        this.$vs.notify({
          color: 'danger',
          title: '실패',
          text: '관리자에게 문의 부탁 드립니다.'
        })
      })
    },
    viewProject(){
      this.$store.commit('space/SET_ACTIVE_SPACE', this.spaceInfo)
      this.$router.push('/apps/space/dashboard/project/'+ this.spaceInfo.id)
    },
    createProject(){
      this.$store.commit('space/SET_ACTIVE_SPACE', this.spaceInfo)
      this.$router.push('/pages/project/create')
    },
    show(){
      if(this.spaceInfo.id){
        this.$store.commit('space/SET_ACTIVE_SPACE', this.spaceInfo)
        this.$router.push('/apps/space/dashboard/main/'+ this.spaceInfo.id)
      }
    },
    userWorkspaceDelete() {
      this.$store.dispatch('space/secessionMemeber', {'id': this.spaceInfo.id, 'title': this.title})
    }
  }
}
</script>

<style>
.text {
    font-size: 14px;
    max-width: 400px;
    line-height: 1.5;
}
</style>
